import { createTheme } from '@mui/material';

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#009c84',
    },
    secondary: {
      main: '#181818',
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
});
